import { Answer, Modal } from './../../../models/qa.model';
import { QaService } from './../../../services/qa.service';
import { Subscription } from 'rxjs/Rx';
import { VisualizerService } from '../../../services/visualizer.service';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Color, ProjectImage, VisualizerStateReady } from '../../../models/color.model';
import { Canvas, CanvasImage } from '../../../models/canvas.model';
import { Router } from '@angular/router';
import { StartupService } from '../../../services/startup.service';
import { Http } from '@angular/http';
import { HistoryService } from '../../../services/history.service';
import { KenticoClassName } from '../../../models/kentico-class-name.enum';
import { ModalComponent } from '../../shared/modal/modal.component';
import { QuestionTypeEnum } from '../../../models/question-type';
import { Empty } from '../../../models/utils.model';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { WoodTypeEnum } from '../../../models/wood-type';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit, OnDestroy {
  @ViewChild('projectContainer') project: ElementRef;
  @ViewChild('blendSpace') blendCanvas: ElementRef;

  visualizerState: VisualizerStateReady;
  visualizerStateSubscription: Subscription;

  subscription: Subscription;
  color: Color;
  isHidden = true;
  projectsList: ProjectImage[];
  currentProjectImage: ProjectImage;
  viewResultTranslation: string;
  public woodCondition: string;

  constructor(
    private qaService: QaService,
    private historyService: HistoryService,
    private startupService: StartupService,
    private visualizerService: VisualizerService,
    private renderer: Renderer2,
    private router: Router,
    private answerInfoService: AnswerInfoService
  ) {
    this.viewResultTranslation = this.startupService.startupData.BrandInfo.ViewResultsTranslation;
  }

  // podpiąć orientation change;
  // @HostListener('window:resize', ['$event'])
  // @HostListener('window:orientationchange', ['$event'])
  // onResize(event) {
  //   if (this.color == null || typeof this.color === 'undefined') {
  //     //this.fitCanvasToContainer();
  //     //this.drawPhotoToCanvas();
  //   } else {
  //     //this.fitCanvasToContainer();
  //     //this.startPainting();
  //   }
  // }

  ngOnInit() {
    this.visualizerStateSubscription = this.visualizerService.isReady.subscribe(state => {
      this.visualizerState = state;

    });
    this.currentProjectImage = this.visualizerService.visualizerData.ProjectImages.find(c => c.IsDefault);
    this.subscription = this.visualizerService.selectedColor.subscribe(c => {
      this.color = c;
      if (this.color != null) {
        this.startPainting();
      }
    });

    this.fitCanvasToContainer();
    this.drawPhotoToCanvas();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.visualizerService.setVisualizerState(new VisualizerStateReady());
    this.visualizerStateSubscription.unsubscribe();
  }

  onHide(isHidden: boolean) {
    this.isHidden = isHidden;
  }

  fitCanvasToContainer() {
    const canvas = this.blendCanvas.nativeElement;
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.maxWidth = '100%';
    this.renderer.setAttribute(canvas, 'width', '768');
    this.renderer.setAttribute(canvas, 'height', '500');
  }

  drawPhotoToCanvas() {
    const canvas = this.blendCanvas.nativeElement;
    let ctx;
    const initImage = new CanvasImage(this.currentProjectImage.ProjectImage, () => {
      ctx = canvas.getContext('2d');
      Canvas.drawImageProp(ctx, initImage.image, 0, 0, canvas.width, canvas.height, 0, 0);
      this.visualizerState.ImageIsLoaded = true;
      this.visualizerService.setVisualizerState(this.visualizerState);
    });
  }

  startPainting(): void {
    this.getCurrentImage();
    this.prepareImages();
  }

  private getCurrentImage(): void {
    const data = this.visualizerService.visualizerData;

    if (data.ProjectImages != null) {
      const colorOpacity = this.color.Opacity;
      let projectImage = data.ProjectImages.find(c => c.Opacity === colorOpacity);
      if (projectImage == null) {
        projectImage = data.ProjectImages.find(c => c.IsDefault);
        if (projectImage == null) {
          projectImage = data.ProjectImages[0];
        }
      }
      this.currentProjectImage = projectImage;
      this.visualizerService.currentProject = projectImage;
    }
  }

  viewResults(event: Event): void {
    this.canProcessStep(event);
    this.qaService.answers.selectedColor = this.color;
    this.visualizerService.setSelectedColor(this.color);

    if (this.color != null) {

      if (this.color.IsElite) {
        const matchingAnswer = this.visualizerService.visualizerData.PostVisualizerAnswers
                                    .filter(x => (
                                              // x.WoodTypeFilter === this.answerInfoService.getSelectedWoodType() &&
                                              x.WoodTypeFilter === this.answerInfoService.getWoodTypeGuid(WoodTypeEnum.All) &&
                                              x.OpacityFilter === this.color.Opacity
                                              )
                                            );

        this.router.navigate(this.startupService.getProductRouterLink(matchingAnswer[0].ProductNodeAlias));
      } else {
        const answers = this.visualizerService.visualizerData.PostVisualizerAnswers;
        const matchingAnswers = answers.filter(x => {
                                    const woodType = this.answerInfoService.getSelectedWoodType();
                                    return (
                                            x.WoodTypeFilter === woodType &&
                                            x.OpacityFilter === this.color.Opacity
                                            );
                                  });
        let answer;
        const damage = this.answerInfoService.getSelectedWoodDamage();
        if (damage !== Empty.GuidValue) {
          answer = matchingAnswers.filter(x => x.WoodDamageFilter === damage)[0];
        } else {
          answer = matchingAnswers[0];
        }
        if (answer.NextActionClassName === KenticoClassName.Product) {
          this.router.navigate(this.startupService.getProductRouterLink(answer.ProductNodeAlias));

        } else {
          const urlArray = this.startupService.getStepRouterLink();
          this.historyService.next(`/${urlArray[1]}/${answer.LinkedActionNodeId}`, this.qaService.answers);
          this.router.navigate(this.startupService.getStepWithNodeRouterLink(answer.LinkedActionNodeId));
        }
      }
    }
  }

  private canProcessStep(event: Event) {
    if (this.color == null) {
      event.stopPropagation();
    }
  }

  private prepareImages() {
    const that = this;
    let width = 0;
    let height = 0;
    const projectImage = new CanvasImage(that.currentProjectImage.ProjectImage, () => {
      const maskImage = new CanvasImage(that.currentProjectImage.MaskImage, () => {
        width = projectImage.image.width;
        height = projectImage.image.height;

        let projectCanvas = new Canvas(width, height);
        let paintArea = new Canvas(width, height);
        const blendSpace = new Canvas(width, height);

        projectCanvas = that.getNonPaintArea(projectImage, maskImage, projectCanvas);
        paintArea = that.getPaintArea(projectImage, maskImage, paintArea);
        if (that.visualizerService.detectIEBrowser()) {

          paintArea.blendMultiplyCustom(that.color);
          blendSpace.ctx.drawImage(projectCanvas.canvas, 0, 0);
          blendSpace.ctx.drawImage(paintArea.canvas, 0, 0);
        } else {

          const colorSpace = new Canvas(width, height);
          blendSpace.ctx.drawImage(paintArea.canvas, 0, 0);
          blendSpace.ctx.globalCompositeOperation = 'multiply';
          colorSpace.blendMultiply(that.color, maskImage);
          blendSpace.ctx.drawImage(colorSpace.canvas, 0, 0);
        }

        const canvas = that.blendCanvas.nativeElement;
        const ctx = canvas.getContext('2d');

        // Fence Only. I dont know why this is offset. I hate this project - jdillon
        if (this.answerInfoService.getSelectedProjectTitle() === 'Fence') {
          Canvas.drawImageProp(ctx, blendSpace.canvas, 0, -6, canvas.width, canvas.height, 0, 0);
        } else {
          Canvas.drawImageProp(ctx, blendSpace.canvas, 0, 0, canvas.width, canvas.height, 0, 0);
        }
      });
    });
  }

  private getNonPaintArea(projectImage: CanvasImage, projectMask: CanvasImage, canvas: Canvas): Canvas {
    return this.getArea(projectImage, projectMask, canvas, 'destination-out');
  }

  private getPaintArea(projectImage: CanvasImage, projectMask: CanvasImage, canvas: Canvas): Canvas {
    return this.getArea(projectImage, projectMask, canvas, 'destination-in');
  }

  private getArea(projectImage: CanvasImage, projectMask: CanvasImage, canvas: Canvas, composition: string): Canvas {
    canvas.paint(function () {
      projectImage.drawOn(canvas);
      canvas.ctx.globalCompositeOperation = composition;
      projectMask.drawOn(canvas);
    });
    return canvas;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/project/project.component.ts